import React from 'react';

import mac from "../Images/efecto_portafolio/mac.png";
import iphone from "../Images/efecto_portafolio/iphone.png";
import macbook from "../Images/efecto_portafolio/macbook.png";

const Desktop = props => {

    return (
        <div className='contenedro_efecto_portafolio contendor-med none-mobil'>
            <div className={'desktop ' + props.images.desktop}>
                <img src={mac} alt="" />
                <div className='imgBx'>
                    
                </div>
            </div>
            <div className={'laptop ' + props.images.laptop}>
                <img src={macbook} alt="" />
                <div className='imgBx'>
                    
                </div>
            </div>
            <div className={'movil ' + props.images.movil}>
                <img src={iphone} alt="" />
                <div className='imgBx'>
                    
                </div>
            </div>
        </div>
    );
};

export default Desktop;